export default __webpack_public_path__ + "static/media/nail_polish_Trim.dba70827.mp4";